// accessibility.js
export const announceMessage = (message) => {
  const liveRegion = document.getElementById("screenReaderLiveRegion");
  if (liveRegion) {
    liveRegion.textContent = "";
    setTimeout(() => {
      liveRegion.textContent = message;
    }, 100);
  }
};
